module.exports = __webpack_public_path__ + "static/media/400115_01.a6f6969d.png";